import { forEach } from 'lodash';

export const selector = 'dbPreventDefault';

/* @ngInject */
export default function PreventDefaultDirective() {
    return {
        restrict: 'A',
        
        link: (scope, element, attrs) => {
            let events = String.prototype.split.call(attrs[selector] || '', ' ');

            forEach(events, (event) => element.on(event, handlePrevention));

            scope.$on('$destroy', () => {
                forEach(events, (event) => element.off(event, handlePrevention));
            });

            function handlePrevention(event) {
                event.preventDefault();
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/common/directive/prevent-default/prevent-default.directive.js